import { LoadingScreen as SharedLoadingScreen } from '../../../components/loading'
import { InsiderView } from '../constants'
import { useInsiderTradingRouter } from '../hooks/useInsiderTradingRouter'

export function LoadingScreen() {
  const insiderTradingRouter = useInsiderTradingRouter()

  // On index page we only use top bar from the module, min height (44px) is precalculated correctly
  // and there's another content already rendered on BE. SharedLoadingScreen has min height
  // which is way more than 44px but in this case even spinner doesn't look good so we're not rendering anything
  if (insiderTradingRouter.viewParams.view === InsiderView.Index) {
    return null
  }

  return <SharedLoadingScreen />
}
